// src/utils/cryptoUtils.js

import CryptoJS from "crypto-js";

const SECRET_KEY = "aabbcc"; // Use a secure key in production

// Encrypt data
export const encrypt = (data) => {
  let encryptedData = CryptoJS.AES.encrypt(data.toString(), SECRET_KEY).toString();
  encryptedData = encodeURIComponent(encryptedData);
  return encryptedData;
};

// Decrypt data
export const decrypt = (encryptedData) => {
  encryptedData = decodeURIComponent(encryptedData);
  const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
  const decryptedId = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedId;
};
